import './CompleteSession.scss';
import React, { MouseEventHandler } from 'react';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import _ from 'lodash';
import {
  TextBlockDescription,
  TextBlockHint,
  SinglePanelWithMessaging,
  SatisfactionSurvey,
} from '../../Components';
import { useExtendedTranslation } from '../../Services/i18nService';
import { SatisfactionScore } from '../../Types/IPatron';
import { setRating } from '../../Services/PatronService';
import useClinicConfig from '../../Hooks/useClinicConfig';

function CompleteSession({
  patron,
  onComplete,
}: {
  patron: any;
  onComplete: MouseEventHandler<HTMLElement>;
}) {
  const t = useExtendedTranslation();

  const onRating = (s: SatisfactionScore) => {
    setRating(patron?.id, s);
  };

  const clinicConfig = useClinicConfig();
  const hasPhoneExtension = !_.isEmpty(_.get(clinicConfig, 'phoneNoExt', ''));

  return (
    <Box display="flex" flex={1}>
      <SinglePanelWithMessaging
        patron={patron}
        title={
          <Typography variant="h5" color="primary" align="center">
            {t('completeSession.title')}
          </Typography>
        }
        footer={
          <Grid container justifyContent="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={onComplete}>
                {t('questionnaire.close')}
              </Button>
            </Grid>
          </Grid>
        }
      >
        <TextBlockDescription>
          {t('completeSession.description.one')}
        </TextBlockDescription>

        <Box marginBottom={1} marginLeft={1}>
          <TextBlockHint>{t('completeSession.description.two')}</TextBlockHint>

          <Grid container justifyContent="center">
            <Grid item sm={8} xs>
              <SatisfactionSurvey onSelectSatisfactionScore={onRating} />
            </Grid>
          </Grid>
        </Box>

        <TextBlockDescription>
          {t('completeSession.description.three')}
        </TextBlockDescription>

        <TextBlockDescription>
          {t(
            hasPhoneExtension
              ? 'completeSession.description.four'
              : 'completeSession.description.fourNoExt',
            { ...clinicConfig }
          )}
        </TextBlockDescription>
      </SinglePanelWithMessaging>
    </Box>
  );
}

export default CompleteSession;
